// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import Vuei18n from 'vue-i18n'
import { sync } from 'vuex-router-sync'
import store from '@/store/store'
import '@mdi/font/css/materialdesignicons.css'
import css from '@/assets/css/darkTheme.css'
import VModal from 'vue-js-modal'
import { languages, defaultLocale } from '../lang/index'

Vue.use(Vuetify)
Vue.use(Vuei18n)
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: false }, injectModalsContainer: true })

new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#55565e',
        new_media: '#16c979',
        myContent: '#f0286e',
        contrast: '#FAFAFF',
        dialog: '#121212',
        screens: '#6352ff',
        broadcast: '#26ab5b',
        menuTooltip: '#55565e',
        allsan: '#D42273'
      },
      dark: {
        primary: '#ffffff',
        new_media: '#13b069',
        myContent: '#f0286e',
        contrast: '#474b66',
        dialog: '#121212',
        screens: '#6352ff',
        broadcast: '#26ab5b',
        menuTooltip: '#474b66',
        allsan: '#D42273'
      }
    }
  }
})
export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    }
  }
})

const opts = {
  icons: {
    iconfont: 'mdiSvg'
  }
}

const messages = Object.assign(languages)

export const i18n = new Vuei18n({
  locale: defaultLocale,
  fallbackLocale: 'fr',
  messages
})

Vue.config.productionTip = false

sync(store, router)

/* eslint-disable no-new, new-cap */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  vuetify: new Vuetify(opts),
  css,
  render: h => h(App),
  components: {App},
  template: '<App/>'
})
